export default function BoxesCountRenderer(boxes) {
    return Number(boxes).toLocaleString('es-AR');
}
